// extracted by mini-css-extract-plugin
export default {"btn_container":"VerifyAction_btn_container__BHn9z"};